<template>
<div v-if="token.role === 'ADM' || token.role === 'CA' ">
  <div class="row mt-5">
    <div class="col text-center">
      <h5>Usuários</h5>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col">
      <form v-on:submit.prevent="save">

        <div class="form-group" v-if="token.role === 'ADM'">
          <label for="empresa">Empresa</label>
          <vue-bootstrap-typeahead v-if="!form._id"
            v-model="form.empresa"
            :data="empresas"
          />
          <input
            v-if="form._id"
            disabled
            type="text"
            class="form-control"
            v-model="form.empresa"
            id="empresa"
          />
        </div>

        <div class="form-group">
          <label for="nome">Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="form.nome"
            id="nome"
            placeholder="Nome"
          />
        </div>
        <div class="form-group">
          <label for="cnpj">Cnpj</label>
          <input
            type="text"
            class="form-control"
            v-model="form.cnpj"
            id="cnpj"
            placeholder=""
          />
        </div>

        <div class="form-group">
          <label for="login">Login</label>
          <input
            type="text"
            class="form-control"
            v-model="form.login"
            id="login"
            placeholder="Login"
          />
        </div>

         <div class="row">
           <div class="col">
            <fieldset>Atividades</fieldset>
              <div class="form-group mt-2">
                <button type="button" @click="addAtTec" class="btn btn-primary btn-raised btn-block">Adicionar</button>
              </div>


           </div>
         </div>
         <div class="row">
           <div class="col" v-for="(item, index) in form.atividades" :key="index">
              <div class="form-group">
                <label :for="'atividade' + index">Atividade</label>
                <atividades v-model="form.atividades[index].atividade" :id="'atividade' + index" />
              </div>

              <div class="form-group mt-2">
                <button type="button" @click="removerAtTec(index)" class="btn btn-danger btn-raised btn-sm btn-block">Remover</button>
              </div>
            </div>
          </div>
          <hr>

        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="text"
            class="form-control"
            v-model="form.email"
            id="email"
            placeholder="Email"
          />
        </div>

        <div class="form-group">
          <label for="campo1">
            Senha (deixa em branco para não alterar)
          </label>
          <input
            type="password"
            class="form-control"
            v-model="form.password"
            id="campo1"
            autocomplete="STOPPPAUTOCOMPLETE"
          />
        </div>

        <div class="form-group">
          <label for="campo3">
            Repetir Senha (deixa em branco para não alterar)
          </label>
          <input
            type="password"
            class="form-control"
            v-model="form.password2"
            id="campo3"
            autocomplete="STOPPPAUTOCOMPLETE"
          />
        </div>

        <div v-if="form.password && form.password !== '' && form.password !== form.password2" class="alert alert-danger">Senhas não conferem</div>
        <div v-if="form.password && form.password !== '' && form.password === form.password2" class="alert alert-success">Senha será alterada ao salvar</div>


        <div class="form-group" v-if="token.role === 'ADM'">
          <label for="email">Permissão</label>
          <select :disabled="form.role === 'ADM'" class="form-control" name="permissao" id="permissao" v-model="form.role">
            <option value="CO">Usuário Interno</option>
            <option value="CA">Usuário Master</option>
            <option value="ADM">Admin</option>
          </select>
        </div>

        <div class="form-group form-check" v-if="form.role === 'CA'">
          <input v-model="form.cadastra" type="checkbox" class="form-check-input" id="cadastra">
          <label class="form-check-label" for="cadastra">Cadastra pelos clientes</label>
        </div>
        <div class="form-group form-check" v-if="form.role === 'CA'">
          <input v-model="form.somenteLeitura" type="checkbox" class="form-check-input" id="somenteLeitura">
          <label class="form-check-label" for="somenteLeitura">Somente visualiza</label>
        </div>

        <div class="form-group">
          <label for="doc">Foto</label><br>
          <img
            v-if="form.filename"
            class="img-fluid img-thumbnail mb-3"
            style="max-height: 200px"
            :src="`${api}/api/v1/usuario/doc/${form.filename}?token=${jwt}&mimetype=${form.mimetype}`"
          />
          <vue-dropzone ref="doc" id="doc" :options="dropzoneOptions" v-on:vdropzone-success="updateDoc"></vue-dropzone>
        </div>

        <div class="form-group mt-2">
          <button class="btn btn-primary btn-raised btn-block">Salvar</button>
          <router-link :to="route" class="btn btn-danger btn-raised btn-block">Cancelar</router-link>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import vueDropzone from 'vue2-dropzone';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

export default {
  components: {
    vueDropzone,
    VueBootstrapTypeahead
  },
  data() {
    return {
      form: {
        nome: '',
        cnpj: '',
        login: '',
        atividades: [],
        password: '',
        role: 'CO',
        cadastra: false,
        somenteLeitura: false,
        email: '',
        empresa: '',
        mimetype: '',
        filename: '',
        originalname: ''
      },
      empresas: [],
      dropzoneOptions: this.$http.getDropzoneConfig(`usuario/upload`, 'post', {
        maxFiles: 1,
        addRemoveLinks: true,
        capture: true,
        dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
        dictRemoveFile: 'Remover'
      }),
      route: '/admin/usuarios'
    };
  },
  methods: {
    removerAtTec(index) {
      this.form.atividades.splice(index, 1);
    },
    addAtTec() {
      this.form.atividades.push({
        atividade: 'AGRICULTURA',
      });
      console.log('add tec');
    },
    save() {
      const method = this.$route.params.id ? this.$http.put : this.$http.post;

      method('/usuario', this.form).then(response => {
        if (response.data.success) {
          this.$toasted.show('Cadastrado com sucesso!', this.$custom.success);
          this.$router.push(this.route);
        } else {
          this.$toasted.show(response.data.err, this.$custom.error);
        }
      });
    },
    updateDoc(file, response) {
      this.form.mimetype = response.mimetype;
      this.form.filename = response.filename;
      this.form.originalname = response.originalname;
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$http.get(`usuario/${this.$route.params.id}`).then(response => {
        if (response.data) this.form = response.data;
      });
    }

    if (this.token.role === 'ADM') {
      this.$http.post(`admin/empresas/listAll`).then(response => {
        if (response.data) this.empresas = response.data;
      });
    }
  }
};
</script>
<style>
.vue-dropzone .dz-preview .dz-details {
  background-color: #0a823b;
}
.vbst-item > span > strong {
  margin-right: 0 !important;
}
.vbt-autcomplete-list {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/app/admin/usuarios/Form.vue